import React from 'react';
import { Link } from 'react-router-dom';
import { UserX } from 'lucide-react';

const ExclusaoConta = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
    <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-6 sm:p-8">
      <div className="flex items-center gap-2 mb-6">
        <UserX className="h-8 w-8 text-primary-600" />
        <h1 className="text-2xl font-bold text-gray-900">Solicitar exclusão de conta e dados</h1>
      </div>
      <p className="text-gray-600 mb-2">SindicoON - Sistema de Gestão de Condomínios</p>

      <div className="prose prose-gray max-w-none space-y-6">
        <p className="text-gray-700 leading-relaxed">
          Esta página descreve como solicitar a exclusão da sua conta e dos seus dados pessoais no aplicativo <strong>SindicoON</strong>.
        </p>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Etapas para solicitar a exclusão da conta</h2>
          <ol className="list-decimal list-inside space-y-2 text-gray-700">
            <li>Entre em contato com o <strong>administrador do seu condomínio</strong> (síndico ou equipe de gestão) ou com o <strong>suporte do SindicoON</strong> pelo formulário disponível na tela &quot;Sobre&quot; do aplicativo ou em Fale Conosco no sistema web.</li>
            <li>Informe o <strong>e-mail ou CPF</strong> da conta que deseja excluir.</li>
            <li>Confirme o pedido de <strong>exclusão da conta e dos dados</strong> associados.</li>
            <li>O processamento do pedido será realizado em até <strong>30 dias úteis</strong>, conforme a operação do sistema e as obrigações do condomínio.</li>
          </ol>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Dados que são excluídos</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            Com a exclusão da conta, serão excluídos ou anonimizados, na medida do possível no sistema e em conformidade com a lei e as regras do condomínio:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-700">
            <li>Dados da conta: e-mail, nome, telefone, vínculo à unidade e ao condomínio.</li>
            <li>Dados de uso no app vinculados ao usuário.</li>
            <li>Fotos e arquivos enviados pelo usuário (encomendas, notas fiscais, achados e perdidos, documentos anexados).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Dados que podem ser mantidos</h2>
          <p className="text-gray-700 leading-relaxed mb-2">
            Alguns dados podem ser mantidos por exigência legal ou pelas regras do condomínio, por exemplo:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-700">
            <li>Registros contábeis e financeiros (cobranças, pagamentos) pelo prazo exigido em lei.</li>
            <li>Histórico necessário à gestão do condomínio, nos prazos definidos pela administração ou pela política do condomínio.</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-2">
            Nesses casos, os dados deixam de estar associados à sua conta e são tratados conforme a política de privacidade e a legislação aplicável.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-900 mt-6 mb-2">Dúvidas</h2>
          <p className="text-gray-700 leading-relaxed">
            Para mais informações sobre privacidade e tratamento de dados, consulte a{' '}
            <Link to="/politica-privacidade" className="text-primary-600 hover:underline font-medium">
              Política de Privacidade do SindicoON
            </Link>
            . Para solicitar a exclusão, use o canal indicado no primeiro passo acima.
          </p>
        </section>
      </div>
    </div>
    </div>
  );
};

export default ExclusaoConta;
